
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["prepareAttackSearch","searchAttack","stepSizeCalculation","startAttack"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "23a33942dc8c66a1dac1.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			